import { render, staticRenderFns } from "./xmlVoiceRecognition.vue?vue&type=template&id=0bfd02ee&scoped=true&"
import script from "./xmlVoiceRecognition.vue?vue&type=script&lang=js&"
export * from "./xmlVoiceRecognition.vue?vue&type=script&lang=js&"
import style0 from "./xmlVoiceRecognition.vue?vue&type=style&index=0&id=0bfd02ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd02ee",
  null
  
)

export default component.exports